'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDateRange = require('react-date-range');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MealFilter = function (_React$Component) {
  _inherits(MealFilter, _React$Component);

  function MealFilter() {
    _classCallCheck(this, MealFilter);

    var _this = _possibleConstructorReturn(this, (MealFilter.__proto__ || Object.getPrototypeOf(MealFilter)).call(this));

    var start = new Date();
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setDate(start.getDate() - 6);

    var end = new Date();
    end.setHours(23);
    end.setMinutes(59);
    end.setSeconds(59);

    _this.state = {
      startDate: (0, _moment2.default)(start),
      endDate: (0, _moment2.default)(end),
      startTime: 0,
      endTime: 23,
      meals: []
    };
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.fetch = _this.fetch.bind(_this);
    _this.filter = _this.filter.bind(_this);
    return _this;
  }

  _createClass(MealFilter, [{
    key: 'fetch',
    value: function fetch(state) {
      var _this2 = this;

      state = state || this.state;
      var start = state.startDate;
      var end = state.endDate;

      _client2.default.service('meals').find({
        query: {
          userid: this.props.user.id,
          date: { $gte: start.toDate(), $lte: end.toDate() },
          $sort: { 'date': '-1' },
          token: _client2.default.get('token')
        }
      }).then(function (data) {
        _this2.setState({ meals: data.data });
        _this2.filter(data.data);
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: 'filter',
    value: function filter(meals, state) {
      meals = meals || this.state.meals;
      state = state || this.state;
      var start = state.startTime;
      var end = state.endTime;
      var filteredMeals = this.state.meals.filter(function (meal) {
        var hours = new Date(meal.date).getHours();
        return start <= hours && hours <= end;
      });
      this.props.onChange(filteredMeals);
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(range) {
      var start = range.startDate;
      start.hours(0);
      start.minutes(0);
      start.seconds(0);

      var end = start.isSame(range.endDate) ? start.clone() : range.endDate;
      end.hours(23);
      end.minutes(59);
      end.seconds(59);

      this.setState({
        startDate: start,
        endDate: end
      });
      this.fetch({
        startDate: start,
        endDate: end
      });
    }
  }, {
    key: 'pickTimeRange',
    value: function pickTimeRange(event, start, end) {
      this.setState({ startTime: start, endTime: end });
      this.filter(this.state.meals, { startTime: start, endTime: end });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var times = [[0, 11, 'Breakfast'], [12, 15, 'Lunch'], [16, 23, 'Dinner'], [0, 23, 'All']].map(function (r, i) {
        var start = r[0];
        var end = r[1];
        var name = r[2];
        var className = '';
        if (_this3.state.startTime === start && _this3.state.endTime === end) {
          className = 'selected';
        }
        return _react2.default.createElement(
          'button',
          {
            key: i,
            className: className,
            onClick: function onClick(e) {
              _this3.pickTimeRange(e, start, end);
            } },
          name
        );
      });
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactDateRange.DateRange, {
          onInit: this.handleSelect,
          onChange: this.handleSelect,
          startDate: this.state.startDate,
          endDate: this.state.endDate
        }),
        times
      );
    }
  }]);

  return MealFilter;
}(_react2.default.Component);

exports.default = MealFilter;


//////////////////
// WEBPACK FOOTER
// ./client/components/MealFilter.jsx
// module id = 218
// module chunks = 0